import { format } from "date-fns";
import { de } from "date-fns/locale";

export function formatDe(date: number | Date, formatStr: string) {
  return format(date, formatStr, {
    locale: de
  });
}
